import React, { Component } from "react";
import { withFirebase } from "../Firebase";
import { Redirect } from "react-router-dom";
import Repeat from "react-repeat-component";
import { Grid, Row, Col } from "react-flexbox-grid";
import { Button, IconButton } from "@material-ui/core";
import { InputGroup } from "@blueprintjs/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import { auth } from "firebase-functions";
import { isReturnStatement } from "typescript";
const day_array = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"];

class TeamMemberPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: "",
      initialized: false,
      redirect: false,
      redirect_url: false,
      availability: [null, null, null, null, null],
      questions: [],
    };
  }

  componentDidMount() {
    this.props.firebase.auth.onAuthStateChanged((user) => {
      this.setState({ user_id: user.uid });
      let user_id = this.state.user_id;
      this.props.firebase.db
        .collection("team_members")
        .doc(user_id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            let auth_code = this.props.location.search.split("?code=");
            if (auth_code[1]) {
              auth_code = auth_code[1];
              console.log(auth_code);
              auth_code = auth_code.split("&")[0];
              console.log(auth_code);
              this.props.firebase.db
                .collection("team_members")
                .doc(user_id)
                .update({ auth_code });
            }
            this.setState({
              questions:
                doc.data().questions != undefined ? doc.data().questions : [],
              availability: this.parseObjectIntoArray(doc.data().availability),
            });
          } else {
            alert(
              "Your team member data has not been initialized. Please follow the prompts to begin initialization"
            );
            let user_data = {
              name: "",
              zoom_url: "",
              availability: {},
              initialized: true,
              email: "",
              user: this.props.firebase.db.collection("users").doc(user_id),
            };
            user_data.name = prompt(
              "Please enter your name as you would like to to be seen on the user facing site and apollo"
            );
            user_data.zoom_url = prompt(
              "Please enter your personal meeting zoom url that beneficiaries will join for consultations"
            );
            user_data.email = prompt(
              "Please enter the email you'd like to have your consultation events sent to"
            );
            alert(
              "Will now continue to authorize apollo to use google calender"
            );
            let url =
              "https://us-central1-thakaa-e6e86.cloudfunctions.net/oauth2init";
            this.props.firebase.db
              .collection("team_members")
              .doc(user_id)
              .set(user_data)
              .then(() => {
                console.log(
                  "Updated with provided data. Will now authorize app to use users google calender"
                );
                this.redirect(url);
              })
              .catch((err) => {
                console.error("Error updating users data: " + err);
              });
          }
        });
    });
  }

  redirect = (url) => {
    this.setState({ redirect_url: url, redirect: true });
  };

  renderRedirect = () => {
    if (this.state.redirect) {
      window.location.href = this.state.redirect_url;
    }
  };

  addQuestions() {
    let questions = this.state.questions;
    questions.push({ type: "", text: "" });
    this.setState({ questions });
  }

  setQuestionText(index, value) {
    let questions = this.state.questions;
    questions[index].text = value;
    questions[index].type = "text";
    this.setState({ questions });
  }

  removeQuestion(index) {
    let { questions } = this.state;
    let newQuestions = [];
    for (let i = 0; i < questions.length; i++) {
      if (i != index) {
        newQuestions.push(questions[i]);
      }
    }
    this.setState({ questions: newQuestions });
  }

  addHours(i) {
    let availability = this.state.availability;
    if (availability[i] === null) {
      availability[i] = [];
    }
    availability[i].push({ start_time: "09:00", end_time: "17:00" });
    this.setState({ availability });
  }

  removeHours(i) {
    let availability = this.state.availability;
    console.log(availability[i]);
    if (availability[i] != null) {
      console.log(availability[i]);
      availability[i].pop();
      console.log(availability[i]);
      if (availability[i].length === 0) {
        availability[i] = null;
      }
    }
    this.setState({ availability });
  }

  setStartTime(i, j, time) {
    let availability = this.state.availability;
    availability[i][j].start_time = time;
    this.setState({ availability });
  }

  setEndTime(i, j, time) {
    let availability = this.state.availability;
    availability[i][j].end_time = time;
    this.setState({ availability });
  }

  parseNestedArrayIntoObject(arr) {
    //our nested arrays have the following format:
    // [[{start_time : "xx:xx", end_time : "xx:xx"},{{start_time : "xx:xx", end_time : "xx:xx"}}],[{}], etc..]
    // to parse it so firebase will accept it, we will transform it into the following object of arrays:
    //{
    //  0:[{start_time: "xx:xx",end_time : "xx:xx"},{start_time: "xx:xx", end_time : "xx:xx"}],
    //  1:[{start_time: "xx:xx",end_time : "xx:xx"},{start_time: "xx:xx",end_time : "xx:xx"}]
    //}
    console.log(arr);
    let arr_object = {};
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === null) {
        continue;
      }
      arr_object[i] = [];
      for (let j = 0; j < arr[i].length; j++) {
        arr_object[i].push(arr[i][j]);
      }
    }
    console.log(arr_object);
    return arr_object;
  }

  parseObjectIntoArray(arr_object) {
    // needed to parse the firestore object back into an array so working with it is ez pz
    // for explanation, see the comments on parseNestedArrayIntoObject, and then reverse it uwu
    let arr = [null, null, null, null, null];
    for (let i = 0; i < arr.length; i++) {
      if (arr_object.hasOwnProperty(i)) {
        arr[i] = [];
        for (let j = 0; j < arr_object[i].length; j++) {
          arr[i].push(arr_object[i][j]);
        }
      } else {
        continue;
      }
    }
    console.log(arr);
    return arr;
  }

  saveChanges(object) {
    this.props.firebase.db
      .collection("team_members")
      .doc(this.state.user_id)
      .update({ availability: object, questions: this.state.questions })
      .then(() => {
        alert("Changes saved");
      });
  }

  render() {
    let { availability, questions } = this.state;
    return (
      <Grid>
        <Row xs="true">
          <Col xs>
            {this.renderRedirect()}
            <Repeat times={5} key="outer_repeat">
              {(i) => {
                return (
                  <Row key={"outer_row_" + i} center="xs">
                    <span key={"outer_span_" + i}>
                      {" "}
                      {day_array[i]}{" "}
                      <IconButton
                        aria-label="add"
                        onClick={() => {
                          this.addHours(i);
                        }}
                        key={"add_hours_button_" + i}
                      >
                        <AddIcon></AddIcon>
                      </IconButton>{" "}
                      <IconButton
                        onClick={() => {
                          this.removeHours(i);
                        }}
                        key={"remove_hours_button_" + i}
                      >
                        <DeleteIcon></DeleteIcon>
                      </IconButton>{" "}
                      <Repeat
                        key="inner_repeat"
                        times={
                          availability[i] === null ? 0 : availability[i].length
                        }
                      >
                        {(j) => {
                          return (
                            <Row key={"inner_row_" + i + ":" + j} center="xs">
                              <InputGroup
                                key={"start_time_" + i + ":" + j}
                                onChange={(event) => {
                                  this.setStartTime(i, j, event.target.value);
                                }}
                                value={
                                  availability[i] === null
                                    ? 0
                                    : availability[i][j].start_time
                                }
                              ></InputGroup>
                              &nbsp;-&nbsp;
                              <InputGroup
                                key={"end_time_" + i + ":" + j}
                                onChange={(event) => {
                                  this.setEndTime(i, j, event.target.value);
                                }}
                                value={
                                  availability[i] === null
                                    ? 0
                                    : availability[i][j].end_time
                                }
                              ></InputGroup>
                            </Row>
                          );
                        }}
                      </Repeat>
                    </span>
                  </Row>
                );
              }}
            </Repeat>
          </Col>
          <Col xs>
            <Repeat times={questions.length} key="questions-repeat">
              {(i) => {
                return (
                  <Col center="xs" key={"quetion-col-" + i}>
                    Quesion&nbsp;{i + 1}
                    <Row center="xs" middle="xs" key={"question-row-" + i}>
                      <InputGroup
                        onChange={(event) => {
                          this.setQuestionText(i, event.target.value);
                        }}
                        value={questions[i].text}
                        key={"question-" + i}
                        large="true"
                        fill="true"
                        rightElement={
                          <IconButton
                            key={"icon-button-" + i}
                            style={{ marginTop: "15%" }}
                            size="small"
                            onClick={() => {
                              this.removeQuestion(i);
                            }}
                            key={"remove_quetion_button_" + i}
                          >
                            <DeleteIcon key={"trash-icon-" + i}></DeleteIcon>
                          </IconButton>
                        }
                      ></InputGroup>
                    </Row>
                  </Col>
                );
              }}
            </Repeat>
            <Row center="xs" middle="xs">
              Add Question
              <IconButton
                aria-label="add"
                onClick={() => {
                  this.addQuestions();
                }}
                key="add-questions-button"
              >
                <AddIcon></AddIcon>
              </IconButton>{" "}
            </Row>
          </Col>
        </Row>
        <Row center="xs">
          <Button
            key="submit"
            onClick={() => {
              this.saveChanges(this.parseNestedArrayIntoObject(availability));
            }}
          >
            Save Changes
          </Button>
        </Row>
      </Grid>
    );
  }
}
export default withFirebase(TeamMemberPage);
